/**
 * 定义计算MA指标类
 */
class MA {
    /**
     * 计算MA指标类构造函数
     * @param {Array<Number>} closes 收盘价集合
     */
    constructor(closes) {
        this.closes = closes || [];
        this.data = {};
        this.seriesOptions = ['#2DB52D', '#D89640', '#E08FE0'].map(color => {
            return {
                type: 'line',
                data: [],
                smooth: true,
                showSymbol: false,
                lineStyle: {
                    color,
                    opacity: 0.5,
                    width: 1
                }
            };
        });
    }

    /**
     * 按照指定日期序列计算MA
     * @param {Array<Number>} dayCounts 要计算MA的日期序列
     */
    calculate(dayCounts = [5, 10, 30]) {
        dayCounts.forEach(dayCount => {
            this.data[dayCount.toString()] = this.calculateMA(dayCount);
        });
    }

    /**
     * 按照指定天数计算MA指标，并返回结果
     * @param {Number} dayCount 要计算几天的MA
     * @returns {Array<Number>} 返回计算结果
     */
    calculateMA(dayCount = 10) {
        let result = [];
        for (let index = 0; index < this.closes.length; index++) {
            if (index < dayCount - 1) {
                result.push(NaN);
                continue;
            }
            let sum = 0;
            for (let i = index - dayCount + 1; i <= index; i++) {
                sum += this.closes[i];
            }
            result.push(sum / dayCount);
        }
        return result;
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        return Object.keys(this.data).map((key, index) => {
            let option = this.seriesOptions[index];
            option.name = 'MA' + key;
            option.data = this.data[key];
            return option;
        });
    }
}

export default MA;



// WEBPACK FOOTER //
// ./src/controller/series/MA.js